import React from "react";
import { SpacePrivacyAction } from "@components/space-actions";
import messages from "../messages.i18n";
import { useIntl } from "react-intl";
import { PeekStack, PeekSwitch, PeekTypography } from "@piiqtechnologies/ui-components";
import { Policy } from "@piiqtechnologies/ui-lib";
export const UnitSpacePrivacyAction = ({ isPublic, onToggle, spaceId }) => {
    const intl = useIntl();
    return (React.createElement(PeekStack, { direction: "row", spacing: 1 },
        React.createElement(PeekTypography, { variant: "h5" }, intl.formatMessage(messages.actionsPrivacy)),
        React.createElement(SpacePrivacyAction, { isPublic: isPublic, spaceId: spaceId, PrivacyComponent: ({ togglePrivacy }) => (React.createElement(Policy, { action: "Space_Edit" /* PolicyActions.SPACE_EDIT */, mode: "disable" },
                React.createElement(PeekSwitch, { size: "medium", sx: { alignSelf: "center" }, "aria-label": "test", inputProps: { "aria-label": intl.formatMessage(messages.actionsPrivacy) }, checked: isPublic, onChange: () => {
                        togglePrivacy(), onToggle();
                    } }))) })));
};
export default UnitSpacePrivacyAction;
